(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-text-bottom"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('#seo-text-bottom-{{ section.id }}').forEach(function(section){
    var body = section.querySelector('.seo-body');
    var toggle = section.querySelector('.seo-toggle');
    if (!body || !toggle) return;

    var lines = body.getAttribute('data-clamp-lines') || 8;
    body.style.setProperty('--clamp', lines);

    var more = toggle.getAttribute('data-more-label') || 'Mehr lesen';
    var less = toggle.getAttribute('data-less-label') || 'Weniger anzeigen';

    toggle.addEventListener('click', function() {
      var clamped = body.classList.toggle('is-clamped');
      var expanded = !clamped;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? less : more;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
